import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility, Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { toJS } from 'mobx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_USAGE, vacantUnitOccupantsCountToSave } from 'src/constants/utilities';
import useStyles from './styles';
import VacantUnitBillsContent from './VacantUnitBillsContent';
import { useStore } from 'src/stores';
const VacantUnitBills = _ref => {
  let disabledTrigger = _ref.disabledTrigger,
    isEdit = _ref.isEdit,
    onSaveAndClose = _ref.onSaveAndClose,
    utility = _ref.utility;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalState = _useState2[0],
    setModalState = _useState2[1];
  const _useState3 = useState(utility.isFetched ? utility.vacantUnitAllocation : utility.defaultVacantUnitAllocation || VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied),
    _useState4 = _slicedToArray(_useState3, 2),
    initLocalVacantUnitAllocation = _useState4[0],
    setInitLocalVacantUnitAllocation = _useState4[1];
  const _useState5 = useState(utility.vacantUnitAllocation || utility.defaultVacantUnitAllocation || VACANT_UNIT_ALLOCATIONS.DivideAmongOccupied),
    _useState6 = _slicedToArray(_useState5, 2),
    localVacantUnitAllocation = _useState6[0],
    setLocalVacantUnitAllocation = _useState6[1];
  const _useState7 = useState(utility.isFetched ? utility.vacantUnitUsage : utility.defaultVacantUnitUsage || VACANT_UNIT_USAGE.NoUsage),
    _useState8 = _slicedToArray(_useState7, 2),
    initLocalVacantUnitUsage = _useState8[0],
    setInitLocalVacantUnitUsage = _useState8[1];
  const _useState9 = useState(utility.vacantUnitUsage || utility.defaultVacantUnitUsage || VACANT_UNIT_USAGE.NoUsage),
    _useState0 = _slicedToArray(_useState9, 2),
    localVacantUnitUsage = _useState0[0],
    setLocalVacantUnitUsage = _useState0[1];
  const modalTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement("span", null, getUtility(toJS(utility).name || toJS(utility).utilityTypeName).icon({
    pattern: 'gradient'
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, getUtility(toJS(utility).name || toJS(utility).utilityTypeName).title, ' ', t('add_new_property_flow.configuration')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, "/ ", t('add_new_property_flow.handling_vacant_unit')));
  const modalSubTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, utility.utilityProviderName);
  const trigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => {
      setModalState(true);
    },
    'custom-attribute': '218-VacantUnitBills'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.edit')));
  const handleClose = e => {
    e === null || e === void 0 || e.preventDefault();
    setLocalVacantUnitAllocation(initLocalVacantUnitAllocation);
    setLocalVacantUnitUsage(initLocalVacantUnitUsage);
    setModalState(false);
  };
  const handleSave = (e, _ref2) => {
    let vacantUnitUsage = _ref2.vacantUnitUsage,
      vacantUnitUsageLimit = _ref2.vacantUnitUsageLimit,
      vacantUnitOccupantsCount = _ref2.vacantUnitOccupantsCount;
    e === null || e === void 0 || e.preventDefault();
    setInitLocalVacantUnitAllocation(localVacantUnitAllocation);
    setInitLocalVacantUnitUsage(localVacantUnitUsage);
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      onSaveAndClose(utility.utilityId);
    } else {
      onSaveAndClose([{
        utility,
        values: [{
          key: 'vacantUnitUsage',
          value: vacantUnitUsage
        }, {
          key: 'vacantUnitUsageLimit',
          value: vacantUnitUsageLimit
        }, ...(store.company.companyFeatureStore.enableVacantUnitOccupantsCount ? [{
          key: 'vacantUnitOccupantsCount',
          value: vacantUnitOccupantsCountToSave(true, vacantUnitUsage, vacantUnitOccupantsCount)
        }] : [])]
      }]);
    }
    setModalState(false);
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disabledTrigger: disabledTrigger,
    handleClose: handleClose,
    handleOpen: () => setModalState(true),
    isOpen: modalState,
    noFooter: true,
    noLeftButton: true,
    noMargin: true,
    subTitle: modalSubTitle,
    title: modalTitle,
    transparentBackdrop: !isEdit,
    trigger: trigger,
    variant: "staticHeight"
  }, /*#__PURE__*/React.createElement(VacantUnitBillsContent, {
    handleSave: handleSave,
    utility: utility
  }));
};
export default VacantUnitBills;